import { render } from "./TableComponent.vue?vue&type=template&id=2087395d&scoped=true&ts=true"
import script from "./TableComponent.vue?vue&type=script&lang=ts"
export * from "./TableComponent.vue?vue&type=script&lang=ts"

import "./TableComponent.vue?vue&type=style&index=0&id=2087395d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2087395d"]])

export default __exports__